import { ProposalSection } from './proposal';

export enum ProjectStatus {
    OPPORTUNITY = 'OPPORTUNITY',
    PROPOSAL = 'PROPOSAL',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}

export enum PositionStatus {
    PLANNED = 'PLANNED',
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    FILLED = 'FILLED',
    CANCELLED = 'CANCELLED'
}

export interface Project {
    id: number;
    name: string;
    description: string;
    status: ProjectStatus;
    statusLabel: string;
    companyId: number;
    clientId: number;
    managerId: number;
    selectedSimulationId?: number;
    client?: {
        id: number;
        name: string;
        description: string;
    };
    company?: {
        id: number;
        name: string;
        cnpj: string;
    };
    manager?: {
        id: number;
        name: string;
        email: string;
        role: string;
    };
    simulation?: ProjectSimulation;
    simulations?: ProjectSimulation[];
    secoes: ProposalSection[];
}

export interface PositionCost {
    id: number;
    position_id: number;
    month: string;
    cost: number;
}

export interface ProjectPosition {
    id: number;
    project_id: number;
    role: string;
    contract_type: string;
    base_salary: number;
    start_date: string;
    end_date: string;
    allocation: number;
    margin: number;
    duration_months: number;
    status: PositionStatus;
    actual_costs?: PositionCost[];
    filled_by_user_id?: number;
    cost?: number;
    position_type: 'cost' | 'bench';
}

export interface MonthlyResult {
    month: string;
    revenue: number;
    costs: number;
    profit: number;
    margin: number;
}

export interface CashFlowResult {
    month: string;
    inflow: number;
    outflow: number;
    balance: number;
}

export interface ProjectSimulation {
    id?: number;
    name: string;
    margin: number;
    start_date: string;
    end_date: string;
    duration_months: number;
    monthly_results: string;  // JSON string
    cash_flow: string;       // JSON string
    total_revenue: number;
    total_costs: number;
    total_profit: number;
    profit_margin: number;
    positions: ProjectPosition[];
    is_selected?: boolean;
    is_approved?: boolean;
    rejection_reason?: string;
} 